import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Container,
  Row,
  Form,
  InputGroup,
} from "react-bootstrap";
import { CiSearch } from "react-icons/ci";
import API from "../config/axios";
import { api_paths } from "../config/api.paths";
import EventCard from "../components/events/EventCard";
import { useSelector } from "react-redux";

const Events = () => {
  const { user } = useSelector((state) => state.USER_DATA);
  const [events, setEvents] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [eventType, setEventType] = useState("all");
  const [isMember, setIsMember] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const [search, setSearch] = useState("");

  const limit = 10;

  useEffect(() => {
    // console.log("Setting user data in Events form:", user);
    if (user && user?.is_membership_active) {
      setIsMember(true);
    }
  }, [user]);

  const fetchEvents = async (type = eventType, page = 1, search = "") => {
    if (page === 1) setInitialLoading(true);
    else setLoadingMore(true);
    try {
      const response = await API.get(
        `${api_paths.member.EVENTS.EVENT_PAGE.GET_LIST}/${type}?filter=${search}&page=${page}&limit=${limit}`
      );
      const data = response.data?.payload?.result?.data || null;
      const total_pages =
        response.data?.payload?.result?.meta?.total_pages || 1;
      setTotalPages(total_pages);
      if (page === 1) {
        setEvents(data); // first load
      } else {
        setEvents((prev) => [...prev, ...data]); // append
      }
      //   console.log("Events response: ", response.data);
    } catch (error) {
      console.error("Error fetching events:", error);
    } finally {
      if (page === 1) setInitialLoading(false);
      else setLoadingMore(false);
    }
  };

  useEffect(() => {
    fetchEvents(eventType, 1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleViewMore = () => {
    const nextPage = page + 1;
    setPage(nextPage);
    fetchEvents(eventType, nextPage);
  };

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
  };

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      fetchEvents(eventType, 1, search);
    }, 500);
    return () => clearTimeout(delayDebounceFn);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  return (
    <Container className="py-5">
      <Row className="mb-4">
        <Col lg={12}>
          <div className="rsvp-header text-center">
            <h1 className="inter-bold h1">Events</h1>
            <p>
              Join us for exciting cultural celebrations and community
              gatherings
            </p>
          </div>
        </Col>
      </Row>

      {/* HEADER FILTERS */}
      <Form>
        <Row className="mb-4">
          <Col lg={9}>
            <InputGroup>
              <Form.Control
                type="text"
                placeholder="Search events by name, description, or location..."
                value={search}
                onChange={handleSearchChange}
              />
              <InputGroup.Text>
                <CiSearch size={20} />
              </InputGroup.Text>
            </InputGroup>
          </Col>

          <Col lg={3} className="d-flex justify-content-center">
            <Form.Select
              aria-label="Sort Events"
              defaultValue="all"
              onChange={(e) => {
                setEventType(e.target.value);
                fetchEvents(e.target.value, 1);
              }}
            >
              <option value="all">All</option>
              <option value="upcoming">Upcoming Events</option>
              <option value="past">Past Events</option>
            </Form.Select>
          </Col>
        </Row>
      </Form>

      {/* EVENTS GRID */}
      <Row className="g-4">
        {/* INITIAL LOAD */}
        {initialLoading &&
          [...Array(6)].map((_, i) => <EventCard key={i} isLoading />)}

        {/* NO EVENTS */}
        {!initialLoading && events.length === 0 && (
          <Col lg={12} className="d-flex justify-content-center my-5">
            <p>No events found.</p>
          </Col>
        )}

        {/* EVENTS LIST */}
        {!initialLoading &&
          events.length > 0 &&
          events.map((item) => (
            <EventCard
              key={item._id}
              item={item}
              isLoading={false}
              isMember={isMember}
            />
          ))}

        {/* LOAD MORE SKELETONS */}
        {loadingMore &&
          [...Array(3)].map((_, i) => <EventCard key={`sk-${i}`} isLoading />)}

        {/* VIEW MORE BUTTON */}
        {!initialLoading && !loadingMore && page < totalPages && (
          <div className="text-center">
            <Button
              onClick={handleViewMore}
              style={{ color: "#FFF" }}
              className="px-4 bg-warning border-0"
            >
              View More
            </Button>
          </div>
        )}
      </Row>
    </Container>
  );
};

export default Events;
